<template>
    <div class="w-screen overflow-x-hidden">
        <header class="w-full py-2 sm:h-16 theme-color">
            <div class="relative container mx-auto h-full flex flex-col sm:flex-row justify-between items-center">
                <p class="text-white flex items-center mb-2">سامانه استخدام ‌<span class="font-bold text-lg">مجتمع آموزشی
                        معلم</span></p>
                <router-link :to="{ name: 'login' }"
                    class="border-white rounded-lg border-2 text-white font-bold bg-transparent px-4 h-10 hidden sm:flex items-center text-sm sm:text-base">ورود
                    / ثبت نام</router-link>
            </div>
        </header>
        <div class="w-full relative">
            <div class="absolute top-0 svgImg w-full opacity-40 transform -translate-x-5">
                <img class="opacity-0" src="@/assets/images/header-in.png" alt="resume">
            </div>
            <div class="svgImg w-full">
                <img src="@/assets/images/header-in.png" alt="resume">
            </div>
            <div class="absolute left-0 top-0 w-5/12 h-[46%] flex justify-center items-center sm:hidden">
                <router-link :to="{ name: 'login' }"
                    class="theme-border rounded-lg border-2 theme-text font-bold bg-transparent px-1 py-1 flex items-center absolute text-sm sm:text-base">ورود
                    / ثبت نام</router-link>
            </div>
            <div class="sm:absolute flex flex-col items-center sm:w-5/12 sm:left-0 sm:top-1/2 sm:-translate-y-1/3 mt-4">
                <h1 class="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-2 text-slate-500">همین حالا درخواست
                    بده
                </h1>
                <p class="text-xs sm:text-sm md:text-base lg:text-lg text-slate-400">همکار ما شو!</p>
                <div class="flex justify-between w-10/12 max-w-xs lg:max-w-sm mt-10 sm:mt-5 lg:mt-10">
                    <router-link :to="{ name: 'jobs' }"
                        class="text-xs lg:text-base rounded-lg text-white hover:text-purple-700 font-bold bg-purple-700 hover:bg-white border-purple-700 border-4 sm:border-2 md:border-4 px-3 py-4 sm:px-2 sm:py-4 md:px-4 md:py-4 lg:px-6 lg:py-4 flex items-center shadow-md">فرصت‌های
                        شغلی</router-link>
                    <router-link to="" @click="goHelp"
                        class="text-xs lg:text-base rounded-lg text-purple-700 hover:text-white border-purple-700 border-4 sm:border-2 md:border-4 font-bold bg-transparent hover:bg-purple-700 px-3 py-4 sm:px-2 sm:py-2 md:px-4 md:py-2 lg:px-6 lg:py-4 flex items-center shadow-md">درخواست
                        همکاری</router-link>
                </div>
            </div>
        </div>
        <div
            class=" flex flex-row items-center justify-evenly sm:justify-between gap-2 my-20 border-gray-100 border-y-4 py-10">
            <div class="hidden sm:block sm:w-8 sm:h-16 md:w-12 md:h-20 lg:w-16 lg:h-28 theme-color"></div>
            <div
                class="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-44 lg:h-44 rounded-2xl bg-pink-800 shadow-lg flex flex-col justify-evenly items-center">
                <p class="text-white text-xs sm:text-sm md:text-base lg:text-lg">درخواست‌ها</p>
                <p class="text-white text-sm sm:text-base md:text-lg lg:text-xl font-bold mb-5">{{
                    landingItems.application_count ? landingItems.application_count + 20 : '20' }}</p>
            </div>
            <div
                class="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-44 lg:h-44 rounded-2xl bg-pink-600 shadow-lg flex flex-col justify-evenly items-center">
                <p class="text-white text-xs sm:text-sm md:text-base lg:text-lg">فرصت‌های فعال</p>
                <p class="text-white text-sm sm:text-base md:text-lg lg:text-xl font-bold mb-5">{{
                    landingItems.position_count ? landingItems.position_count : '0' }}</p>
            </div>
            <div
                class="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-44 lg:h-44 rounded-2xl bg-amber-600 shadow-lg flex flex-col justify-evenly items-center">
                <p class="text-white text-xs sm:text-sm md:text-base lg:text-lg">قبول شده‌ها</p>
                <p class="text-white text-sm sm:text-base md:text-lg lg:text-xl font-bold mb-5">{{
                    landingItems.accepted_count ? landingItems.accepted_count + 10 : '10' }}</p>
            </div>
            <div class="hidden sm:block sm:w-8 sm:h-16 md:w-12 md:h-20 lg:w-16 lg:h-28 theme-color"></div>
        </div>
        <div class="flex flex-col items-center justify-evenly">
            <h2 ref="help" class="text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-10 sm:mb-20 sm:mt-10 text-slate-500">چطور
                همکار ما
                بشی؟</h2>
            <div class="flex flex-col sm:flex-row items-center justify-evenly container">
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        1</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        اول توی سایت ‌<router-link :to="{ name: 'register' }" class="text-blue-600">ثبت نام</router-link>‌
                        کن
                    </div>
                </div>
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        2</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        <router-link :to="{ name: 'login' }" class="text-blue-600">ورود</router-link>‌ به سایت رو بزن و وارد
                        شو
                    </div>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row items-center justify-evenly container">
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        3</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        پروفایلت رو تکمیل کن</div>
                </div>
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        4</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        وارد بخش موقعیت‌های شغلی شو</div>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row items-center justify-evenly container">
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        5</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        شغل مورد نظرتو درخواست بده</div>
                </div>
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        6</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        منتظر بمون تا درخواستت تایید بشه</div>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row items-center justify-evenly container">
                <div class="flex items-center shadow-md p-2 rounded-full w-10/12 sm:w-5/12 mb-7">
                    <div
                        class="flex items-center justify-center bg-blue-50  text-slate-500 shadow-inner rounded-full text-sm sm:text-base w-10 h-10">
                        7</div>
                    <div
                        class="flex items-center justify-center text-slate-500 w-[calc(100%-2.5rem)] text-xs sm:text-sm md:text-base">
                        تبریک میگم همکار ما شدی!</div>
                </div>
            </div>
        </div>
        <footer class="w-full relative !bg-transparent mt-10">
            <svg class="absolute bottom-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path class="theme-svg" fill-opacity="0.4"
                    d="M0,256L60,234.7C120,213,240,171,360,133.3C480,96,600,64,720,90.7C840,117,960,203,1080,208C1200,213,1320,139,1380,101.3L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
                </path>
            </svg>
            <svg class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path class="theme-svg" fill-opacity="1"
                    d="M0,128L60,133.3C120,139,240,149,360,160C480,171,600,181,720,154.7C840,128,960,64,1080,48C1200,32,1320,64,1380,80L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
                </path>
            </svg>
            <svg class="absolute bottom-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path class="theme-svg" fill-opacity="0.2"
                    d="M0,96L80,85.3C160,75,320,53,480,85.3C640,117,800,203,960,208C1120,213,1280,139,1360,101.3L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z">
                </path>
            </svg>
            <div class="absolute theme-color bottom-0 flex flex-col items-center justify-center text-center w-full py-3">
                <p class="text-white text-xs sm:text-sm md:text-bas lg:text-lg">آدرس : تهران - بلوار دریا - روبروی پارک
                    دلاوران -
                    مجتمع اموزشی معلم</p>
                <p class="text-gray-200 my-2 sm:my-3 md:my-4 lg:my-5 text-xs">تمامی حقوق این سایت برای مجتمع آموزشی معلم
                    محفوظ
                    میباشد©</p>
            </div>
        </footer>
    </div>
</template>

<script setup>
// import
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

// data
const store = useStore();

// refs in template
const help = ref(null);


onMounted(() => {
    getLandingItems();
})

// methods
function goHelp() {
    help.value.scrollIntoView();
}

// api
function getLandingItems() {
    store.dispatch("getStatisticsFromApi");
}

const landingItems = computed(() => {
    return store.getters.getStatistics;
})
</script>

<style lang="scss">
.svgImg {
    background-color: var(--color);
    -webkit-mask: url(@/assets/images/hf-path.svg) no-repeat center;
    mask: url(@/assets/images/hf-path.svg) no-repeat center;
    -webkit-mask-size: cover;
    mask-size: cover;
}</style>